module.exports = __webpack_public_path__ + "static/media/brown-cooperate.58c4cf8e.jpg";